export default function (value) {
  if (value === null || typeof value === 'undefined' || typeof value === 'string' && value.trim() == '') {
    return false;
  }

  const dateTimeArray = value['date'].split(' ');
  const date = dateTimeArray[0];
  const time = dateTimeArray[1];

  return !!date && !!time;
};
